import(/* webpackMode: "eager", webpackExports: ["DemoView"] */ "/var/www/vhosts/castly.nl/httpdocs/src/components/marketing/demo-view.tsx");
